import { render, staticRenderFns } from "./FinanceremittanceDetailBox.vue?vue&type=template&id=ef79e16c"
import script from "./FinanceremittanceDetailBox.vue?vue&type=script&lang=js"
export * from "./FinanceremittanceDetailBox.vue?vue&type=script&lang=js"
import style0 from "./FinanceremittanceDetailBox.vue?vue&type=style&index=0&id=ef79e16c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports